// Runs once even if the script is loaded more than once
(function () {
  if (window.__extendIntegrationInitialized) return;
  window.__extendIntegrationInitialized = true;

  // Pauses cart normalization while a PDP add-to-cart is in flight, so the plan
  // isn't removed as an orphan before its covered product reaches the cart.
  let suppressCartNormalize = false;

  // ! ||--------------------------------------------------------------------------------||
  // ! ||                        THEME ADAPTER  (Sleek / FoxTheme — Dawn)                 ||
  // ! ||--------------------------------------------------------------------------------||
  // Theme-specific selectors and events for the Sleek theme. This is the only part
  // that differs from the base template — see INTEGRATION_GUIDE.md.
  const THEME = {
    // Sleek re-renders the cart (drawer + main cart) by replacing innerHTML and then
    // dispatches cart:updated on document.
    events: {
      cartUpdate: "cart:updated",
      contentUpdate: "cart:updated",
    },

    // Product detail page
    pdp: {
      container: ".product-form", // wraps the variant input and ATC button
      variantInput: '[name="id"]', // hidden input holding the selected variant id
      addToCartButton: 'button[name="add"]', // buy button
      offerAnchor: ".product-form__buttons", // offer renders just above the ATC area
    },

    // Full cart page
    cartPage: {
      cartContainer: "main-cart",
      cartRowItem: ".cart-item",
      cartRowItemImage: ".cart-item__media",
      cartRowItemTitle: ".cart-item__title",
      cartRowItemQuantity: ".quantity__input",
      warrantyOriginalMeta: ".cart-item__options",
      offerAnchor: ".cart-item__product--info", // where the offer is appended
      metadataContainer: ".cart-item__options",
      optionRow: ".cart-item__option-value", // variant option rows; the price one is removed
      variationClass: "cart-item__option-value",
      quantityWrapper: ".cart-item__quantity-wrapper",
    },

    // Cart drawer / side cart
    sideCart: {
      cartContainer: ".cart-drawer__body",
      cartRowItem: ".cart-item",
      cartRowItemImage: ".cart-item__media",
      cartRowItemTitle: ".cart-item__title",
      cartRowItemQuantity: ".quantity__input",
      warrantyOriginalMeta: ".cart-item__options",
      offerAnchor: ".cart-item__details", // where the offer is appended
      metadataContainer: ".cart-item__options",
      optionRow: ".cart-item__option-value", // variant option rows; the price one is removed
      variationClass: "cart-item__option-value",
      quantityWrapper: ".cart-quantity",
      lineItemRemove: ".cart-item__remove",
    },

    // This theme renders line-item properties (Product, Term) natively, so we don't
    // re-add them — we only strip the plan's price-like variant option row.
    addPlanMeta: false,

    // Re-render the drawer after a plan is added/removed
    triggerSideCartRefresh: function () {
      document.dispatchEvent(
        new CustomEvent("cart:refresh", { bubbles: true, detail: { open: true } }),
      );
    },

    // Builds one plan-metadata row ("Product" / "Plan") when addPlanMeta is enabled.
    buildMetaRow: function (key, value, selectors) {
      const span = document.createElement("span");
      if (selectors.variationClass) span.className = selectors.variationClass;
      span.textContent = `${key}: ${value}`;
      return span;
    },
  };

  // ! ||--------------------------------------------------------------------------------||
  // ! ||                                   PDP Offers                                   ||
  // ! ||--------------------------------------------------------------------------------||

  /**
   * Returns a variant's price in cents from meta, or null when not found.
   */
  function getVariantPrice(variantId) {
    if (!meta || !meta.product || !meta.product.variants) return null;
    const variant = meta.product.variants.filter(
      (v) => v.id == variantId,
    )[0];
    return variant ? variant.price : null;
  }

  class ExtendProductOffer extends HTMLElement {
    constructor(container, variantInput, addToCartButton) {
      super();

      this.container = container;
      this.variantInput = variantInput;
      this.addToCartButton = addToCartButton;

      const referenceId = variantInput.value;
      const price = getVariantPrice(referenceId);
      const category = meta.product.type;

      this.params = {
        referenceId,
        price,
        category,
      };

      this.config = getConfiguration();
      this.config.dispatchSideCart = false;
    }

    connectedCallback() {
      try {
        this.verifyProductOffer();
      } catch (err) {
        console.error(err.message);
        return;
      }

      this.bindEvents();
      this.style.display = "block";

      if (!this.config.pdpOfferEnabled) this.style.display = "none";
      // Renders Extend offer
      Extend.buttons.render(this, this.params, () => {
        setTimeout(() => {
          window.dispatchEvent(new Event("resize"));
        }, 250);
      });
    }

    bindEvents() {
      this.handleAddToCart = this.handleAddToCart.bind(this);
      this.handleVariantChange = this.handleVariantChange.bind(this);

      document.addEventListener("click", this.handleAddToCart, true);

      // Fires on variant/swatch selection
      this.container.addEventListener("change", this.handleVariantChange, true);

      // Fires when the variant input's value attribute changes
      try {
        this.variantObserver = new MutationObserver(this.handleVariantChange);
        this.variantObserver.observe(this.variantInput, {
          attributes: true,
          attributeFilter: ["value"],
        });
      } catch (err) {
        /* MutationObserver unavailable */
      }
    }

    verifyProductOffer() {
      let elementsToCheck = [
        "this.container",
        "this.variantInput",
        "this.addToCartButton",
        "this.params.referenceId",
        "this.params.price",
        "this.params.category",
      ];

      let missingElements = elementsToCheck.filter((value) => {
        try {
          return !eval(value);
        } catch (err) {
          return true;
        }
      });

      if (missingElements.length) {
        let message = "The following value(s) are null or undefined:\n";
        missingElements.forEach((value) => {
          message += `\t${value}\n`;
        });
        throw new ExtendError(message);
      }

      // Checks if Extend lives in the window and the active currency is USD before showing Extend offers
      verifyExtend();
    }

    modalDone() {
      // remove default click listener
      document.removeEventListener("click", this.handleAddToCart, true);

      // Resume normalization only after the covered product is confirmed in the cart
      const referenceId = this.params.referenceId;
      const deadline = Date.now() + 12000;
      const settle = () => {
        getCart().then((currentCart) => {
          const productInCart = currentCart.items.some(
            (item) => item.variant_id == referenceId,
          );
          if (productInCart || Date.now() > deadline) {
            suppressCartNormalize = false;
            initCartOffer();
          } else {
            document.addEventListener(THEME.events.cartUpdate, settle, {
              once: true,
            });
          }
        });
      };
      document.addEventListener(THEME.events.cartUpdate, settle, { once: true });

      // click atc button
      this.addToCartButton.click();
      // add default click listener back
      document.addEventListener("click", this.handleAddToCart, true);
    }

    /**
     * Handle add to cart event with offers
     * @param {PointerEvent} e Click event from Add To Cart Button
     */
    handleAddToCart(e) {
      const clickedButton =
        e.target && e.target.closest ? e.target.closest("button") : null;
      if (clickedButton !== this.addToCartButton) return;

      e.preventDefault();
      e.stopImmediatePropagation();

      const quantityEl = this.container.querySelector('[name="quantity"]');
      const quantity = quantityEl && quantityEl.value ? quantityEl.value : 1;

      // Hold normalization until the product lands in the cart (see modalDone)
      suppressCartNormalize = true;

      ExtendShopify.handleAddToCart(this, {
        quantity: quantity,
        modal: this.config.offerModalEnabled,
        done: this.modalDone.bind(this),
      });
    }

    handleVariantChange() {
      const newReferenceId = this.variantInput.value;
      if (!newReferenceId || newReferenceId === this.params.referenceId) return;

      this.params.referenceId = newReferenceId;
      this.params.price = getVariantPrice(newReferenceId);

      Extend.setActiveProduct(this, this.params);
      setTimeout(() => {
        window.dispatchEvent(new Event("resize"));
      }, 250);
    }
  }
  if (!customElements.get("extend-offer"))
    customElements.define("extend-offer", ExtendProductOffer);

  /**
   * Initializes product offers and handles ATC button functionality for the main PDP ATC
   */
  function initProductOffer() {
    try {
      if (meta.page.pageType != "product" || !meta.product)
        throw new ExtendError(
          "Extend Product Offer - The current page is not a product page",
        );
    } catch (err) {
      console.warn(err.message);
      return;
    }

    const container = document.querySelector(THEME.pdp.container);
    const variantInput = container
      ? container.querySelector(THEME.pdp.variantInput)
      : null;
    const addToCartButton = container
      ? container.querySelector(THEME.pdp.addToCartButton)
      : null;

    if (!container || !variantInput || !addToCartButton) {
      console.warn(
        "EXTEND: Could not locate the product form, variant input, or buy button — PDP offer skipped",
      );
      return;
    }

    const extendOffer = new ExtendProductOffer(
      container,
      variantInput,
      addToCartButton,
    );

    // Render the offer just above the ATC area (or the form if no anchor)
    const anchor =
      (THEME.pdp.offerAnchor && container.querySelector(THEME.pdp.offerAnchor)) ||
      container;
    anchor.parentElement.insertBefore(extendOffer, anchor);
  }

  // ! ||--------------------------------------------------------------------------------||
  // ! ||                                   Cart Offers                                  ||
  // ! ||--------------------------------------------------------------------------------||

  const cartOfferTag = "extend-cart-offer";

  class ExtendCartOffer extends HTMLElement {
    constructor(referenceId, category, price, quantity, type) {
      super();
      this.params = {
        referenceId,
        category,
        price,
        quantity,
      };
      this.type = type;

      this.config = getConfiguration();
    }

    connectedCallback() {
      if (!this.canDisplayOffer()) {
        return;
      }

      Extend.buttons.renderSimpleOffer(this, {
        ...this.params,
        onAddToCart: ({ plan, product }) => {
          ExtendShopify.addPlanToCart(
            {
              plan,
              product,
              quantity: this.params.quantity,
            },
            (err) => {
              if (err) {
                throw new ExtendError(err.message);
              }

              document.dispatchEvent(
                new CustomEvent("extend.plan-update", {
                  detail: { offer: this },
                }),
              );
            },
          );
        },
      });
    }

    canDisplayOffer() {
      return (
        (this.type === "main" && this.config.cartOfferEnabled) ||
        (this.type === "side" && this.config.sideCartOfferEnabled)
      );
    }
  }
  if (!customElements.get(cartOfferTag))
    customElements.define(cartOfferTag, ExtendCartOffer);

  const initCartOffer = (() => {
    var cart;
    var init = false;

    const {
      cartOfferEnabled,
      cartSPEnabled,
      sideCartOfferEnabled,
      cartBalancingEnabled,
      SPEnabled,
    } = getConfiguration();

    let type, selectors, pageType;

    // Resolves the cart type and selectors from the current page
    function resolveCartContext() {
      try {
        pageType = meta.page.pageType;
      } catch (err) {
        pageType = undefined;
      }

      if (pageType === "cart" && (cartOfferEnabled || cartSPEnabled)) {
        selectors = THEME.cartPage;
        type = "main";
      } else if (sideCartOfferEnabled && THEME.sideCart) {
        selectors = THEME.sideCart;
        type = "side";
      }
    }

    function createWarrantyOffer(lineItemElement, index) {
      if (!cartOfferEnabled && type === "main") return;
      if (!sideCartOfferEnabled && type === "side") return;

      const anchor = lineItemElement.querySelector(selectors.offerAnchor);
      if (!anchor) {
        throw new ExtendError(
          `Offer anchor element on line ${index} not found with selector ${selectors.offerAnchor}`,
        );
      }

      const container = anchor.querySelector("div[extend-bundle-offer]");

      const cartItem = cart.items[index];
      const referenceId = container
        ? container.dataset.referenceId
        : cartItem.variant_id;
      const quantity = container ? container.dataset.quantity : cartItem.quantity;
      const price = container ? container.dataset.price : cartItem.price;
      const category = container
        ? container.dataset.category
        : cartItem.product_type;
      const warrantyAlreadyInCart =
        ExtendShopify.warrantyAlreadyInCart(referenceId, cart.items) ||
        ExtendShopify.warrantyAlreadyInCart(referenceId.toString(), cart.items);

      const extendOffer = lineItemElement.querySelector(cartOfferTag);

      // If there's already an offer element, check that the properties match what we are trying to create
      // If they do not match, or the warranty is already in cart, remove the offer
      if (extendOffer) {
        if (
          extendOffer.params.referenceId !== referenceId ||
          extendOffer.params.quantity !== quantity ||
          extendOffer.params.price !== price ||
          extendOffer.params.category !== category ||
          warrantyAlreadyInCart
        ) {
          extendOffer.remove();
          // If they do match and the warranty is not already in the cart, do not create a new offer
        } else {
          return;
        }
        // If there is no offer element, but the warranty is already in cart, do not create a new offer
      } else if (warrantyAlreadyInCart) {
        return;
      }

      const newExtendOffer = new ExtendCartOffer(
        referenceId,
        category,
        price,
        quantity,
        type,
      );

      // Side cart: place the offer above the quantity stepper; otherwise append
      const quantityWrapper = anchor.querySelector(selectors.quantityWrapper);
      if (type === "side" && quantityWrapper) {
        anchor.insertBefore(newExtendOffer, quantityWrapper);
      } else {
        anchor.append(newExtendOffer);
      }
    }

    function styleWarrantyLineItem(lineItemElement, index) {
      const title = lineItemElement.querySelector(selectors.cartRowItemTitle);
      if (title) {
        title.style.pointerEvents = "none";
        title.innerText = "Extend Protection Plan";
      }

      const image = lineItemElement.querySelector(selectors.cartRowItemImage);

      if (image) {
        image.style.pointerEvents = "none";
      } else {
        console.error(
          `EXTEND: Line item image element on line ${index} not found with selector ${selectors.cartRowItemImage}`,
        );
      }

      // Remove only the plan's price-only option row (a stray price-like value); leave
      // any real options the theme renders in place.
      const optionRow = selectors.optionRow || `.${selectors.variationClass}`;
      lineItemElement.querySelectorAll(optionRow).forEach((row) => {
        if (row.classList.contains("extend-warranty-info")) return;
        const text = (row.textContent || "").trim();
        const isPrice = /[$£€]/.test(text) || /\d[\d,]*\.\d{2}\b/.test(text);
        if (isPrice) row.remove();
      });

      // This theme renders the plan's Product/Term properties natively, so we skip
      // re-adding them (THEME.addPlanMeta === false). Enable to build them if needed.
      if (THEME.addPlanMeta) {
        const properties = (cart.items[index] && cart.items[index].properties) || {};

        let productName = properties["Product"];
        if (productName === "Covered Product") {
          const productId = properties["_Extend.ProductId"];
          const covered = cart.items.filter((item) => {
            const id = item.variant_id || item.id || item.variantId;
            return id != null && id.toString() == productId;
          })[0];
          if (covered) productName = covered.product_title || covered.title;
        }

        const metadata = [];
        if (productName) metadata.push(["Product", productName]);
        if (properties["Term"]) metadata.push(["Plan", properties["Term"]]);

        if (metadata.length && !lineItemElement.querySelector(".extend-warranty-info")) {
          const container = selectors.metadataContainer
            ? lineItemElement.querySelector(selectors.metadataContainer)
            : null;

          let refNode = title;
          metadata.forEach(([key, value]) => {
            const row = THEME.buildMetaRow(key, value, selectors);
            row.classList.add("extend-warranty-info");
            if (container) {
              container.append(row);
            } else if (refNode) {
              refNode.insertAdjacentElement("afterend", row);
              refNode = row;
            } else {
              lineItemElement.append(row);
            }
          });
        }
      }

      if (
        selectors.quantityWrapper?.length &&
        lineItemElement.querySelector(selectors.quantityWrapper)
      ) {
        lineItemElement
          .querySelectorAll(selectors.quantityWrapper)
          .forEach((each) => {
            each.style.opacity = "75%";
            each.style.pointerEvents = "none";
          });
      }
    }

    function formatLineItems() {
      let cartContainer = document.querySelector(selectors.cartContainer);

      if (!cartContainer) {
        throw new ExtendError(
          `Invalid cart container selector: ${selectors.cartContainer}`,
        );
      }

      cartContainer
        .querySelectorAll(selectors.cartRowItem)
        .forEach((lineItemElement, index) => {
          let title = lineItemElement.querySelector(selectors.cartRowItemTitle);

          if (!title) {
            console.warn(
              `EXTEND: Line item title not found on line ${index} with selector ${selectors.cartRowItemTitle} — skipping`,
            );
            return;
          }

          let lowerCaseTitle = title.innerHTML.toLowerCase();

          if (lowerCaseTitle.includes("extend protection")) {
            styleWarrantyLineItem(lineItemElement, index);
          } else {
            createWarrantyOffer(lineItemElement, index);
          }
        });
    }

    function normalizeItems(callback) {
      getCart()
        .then((newCart) => {
          const cartContainer = document.querySelector(selectors.cartContainer);
          const bundleOffers = cartContainer
            ? cartContainer.querySelectorAll("div[extend-bundle-offer]")
            : [];
          bundleOffers.forEach((bundle) => {
            newCart.items[bundle.dataset.cartIdx].variant_id =
              bundle.dataset.referenceId;
          });
          return newCart;
        })
        .then((newCart) => {
          if (SPEnabled) {
            ExtendShopify.updateExtendLineItems({
              balanceCart: cartBalancingEnabled,
              isSPSupported: cartSPEnabled,
              callback,
            });
          } else {
            let normalizationOpts = {
              balance: cartBalancingEnabled,
              cart: newCart,
            };
            ExtendShopify.normalizeCart(normalizationOpts, callback);
          }
        });
    }

    function refreshCart() {
      if (type === "side") {
        THEME.triggerSideCartRefresh();
      } else {
        location.reload();
      }
    }

    function verifyCartOffers() {
      verifyExtend();

      let error = "";
      if (!selectors) error = `Cart selectors are empty\n`;

      if (!type) error += `Cart type not defined\n`;

      if (error.length > 0) {
        throw new ExtendError(
          `Cannot initialize cart offers due to following errors:\n${error}`,
        );
      }
    }

    function initEventListeners() {
      if (type === "main") {
        // Re-inject offers after the cart list re-renders
        document.addEventListener(THEME.events.contentUpdate, () => {
          onCartUpdate();
        });
      } else {
        // Re-inject offers when the drawer changes
        document.addEventListener(THEME.events.cartUpdate, (event) => {
          const detail = event.detail || {};
          if (detail.source === "extend-cart") return;
          onCartUpdate();
        });
        document.addEventListener(THEME.events.contentUpdate, () => {
          onCartUpdate();
        });
      }

      // When a plan is added to the cart, re-render the side cart, then (after it has
      // settled) re-fetch the cart and re-run formatLineItems so the new plan line gets
      // its metadata fixed.
      document.addEventListener("extend.plan-update", () => {
        refreshCart();
        setTimeout(() => {
          getCart().then((currentCart) => {
            cart = currentCart;
            formatLineItems();
          });
        }, 500);
      });

      init = true;
    }

    function onCartUpdate() {
      if (suppressCartNormalize) return;
      normalizeItems((err, data) => {
        cart = data.cart;
        if (err) {
          throw new ExtendError(err);
        }

        if (data?.updates) {
          refreshCart();
        }

        // Render offers + fix plan metadata AFTER the side cart finishes its
        // post-normalize update. Running immediately renders them, but the ensuing
        // side-cart update wipes them — so delay the render until that has settled.
        setTimeout(() => {
          formatLineItems();
        }, 500);
      });
    }

    return function initCartOffer() {
      resolveCartContext();

      // Only run where there is a cart context (cart page, or a side cart). On other
      // pages (e.g. PDP) bail quietly instead of erroring.
      const onCartPage =
        pageType === "cart" || /cart/.test(window.location.pathname);
      if (!type || (!onCartPage && !sideCartOfferEnabled)) {
        return;
      }

      try {
        verifyCartOffers();
      } catch (err) {
        console.warn(err.message);
        return;
      }

      if (!init) initEventListeners();

      if (document.querySelector(selectors.cartContainer)) {
        onCartUpdate();
      }
    };
  })();

  // ! ||--------------------------------------------------------------------------------||
  // ! ||                                      Utils                                     ||
  // ! ||--------------------------------------------------------------------------------||
  class ExtendError extends Error {
    constructor(message) {
      super(message);
    }
  }

  function getConfiguration() {
    return {
      currency: "USD",
      pdpOfferEnabled: true,
      offerModalEnabled: true,
      cartOfferEnabled: true,
      sideCartOfferEnabled: true,
      cartBalancingEnabled: true,
      aftermarketModalEnabled: true,
      atcOfferEnabled: true,
      quickviewOfferEnabled: false,
      quickviewModalOfferEnabled: false,
      cartSPEnabled: false,
      SPEnabled: false,
    };
  }

  function verifyExtend() {
    const propertiesToCheck = [
      "window.Extend",
      "window.ExtendShopify",
      "window.Shopify",
      "window.Shopify.currency.active",
    ];

    function checkPropertyExists(path) {
      return (
        path.split(".").reduce((obj, prop) => obj && obj[prop], window) !==
        undefined
      );
    }

    let errors = propertiesToCheck.filter((prop) => !checkPropertyExists(prop));

    // Check for currency mismatch
    if (window.Shopify?.currency?.active !== getConfiguration().currency) {
      errors.push("window.Shopify.currency.active == config.currency");
    }

    if (errors.length) {
      let message = "The following value(s) are null, undefined, or false:\n";
      errors.forEach((error) => {
        message += `\t${error}\n`;
      });
      throw new ExtendError(message);
    }
  }

  function initAftermarket() {
    try {
      verifyExtend();

      // Get params from URL
      const params = new URL(document.location).searchParams;

      // Check if leadToken or leadtoken is in the URL
      let leadToken = params.get("leadToken")
        ? params.get("leadToken")
        : params.get("leadtoken");

      if (leadToken) {
        Extend.aftermarketModal.open({
          leadToken: leadToken,
          onClose: function (plan, product, quantity) {
            if (plan && product) {
              ExtendShopify.addPlanToCart(
                {
                  plan: plan,
                  product: product,
                  leadToken: leadToken,
                  quantity: quantity || 1,
                },
                function () {
                  location = "/cart";
                },
              );
            }
          },
        });
      }
    } catch (error) {
      throw new ExtendError(error.message);
    }
  }

  function getCart() {
    return fetch("/cart.js", {
      credentials: "same-origin",
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
    }).then((e) => e.json());
  }

  // Integration init
  window.addEventListener("extend.integration", () => {
    try {
      const storeId = "68a89331-04f9-422a-b9d3-527304628964";
      const environment = "production";

      window.Extend.config({ storeId, environment });

      const config = getConfiguration();

      if (config.aftermarketModalEnabled) initAftermarket();

      if (
        config.atcOfferEnabled ||
        config.offerModalEnabled ||
        config.pdpOfferEnabled
      )
        initProductOffer();

      if (
        config.cartOfferEnabled ||
        config.cartSPEnabled ||
        config.sideCartOfferEnabled
      )
        initCartOffer();
    } catch (err) {
      console.error(err);
    }
  }, { once: true });
})();
